<template>
    <div class="block block-products-carousel" data-layout="grid-5">      
      <div class="container">              
        <div class="section-header">                
          <div class="section-header__body">                  
            <h2 class="section-header__title">Featured Products</h2>                  
            <div class="section-header__spring">
            </div>                  
            <div class="section-header__arrows">                    
              <div class="arrow section-header__arrow section-header__arrow--prev arrow--prev arrow__button-prev-featured" @click="swiperPrev">                      
                <button class="arrow__button" type="button">                        
                  <svg width="7" height="11">                          
                    <path d="M6.7,0.3L6.7,0.3c-0.4-0.4-0.9-0.4-1.3,0L0,5.5l5.4,5.2c0.4,0.4,0.9,0.3,1.3,0l0,0c0.4-0.4,0.4-1,0-1.3l-4-3.9l4-3.9C7.1,1.2,7.1,0.6,6.7,0.3z" />                        
                  </svg>                      
                </button>                    
              </div>				
              <button type="button" class="section-header__groups-button section-header__groups-button--active">View More
              </button>                    
              <div class="arrow section-header__arrow section-header__arrow--next arrow--next" @click="swiperNext">                      
                <button class="arrow__button" type="button">                        
                  <svg width="7" height="11">                          
                    <path d="M0.3,10.7L0.3,10.7c0.4,0.4,0.9,0.4,1.3,0L7,5.5L1.6,0.3C1.2-0.1,0.7,0,0.3,0.3l0,0c-0.4,0.4-0.4,1,0,1.3l4,3.9l-4,3.9 	C-0.1,9.8-0.1,10.4,0.3,10.7z" />                        
                  </svg>                      
                </button>                    
              </div>                  
            </div>                
          </div>              
        </div>              
        <div class="block-products-carousel__carousel">                
          <div class="block-products-carousel__carousel-loader"></div>
<!-- :autoplay="{delay: 3000}"
              :loop=false -->
          <swiper id="swiperFeatured"
              :slides-per-view="slides.perPage"
              :space-between="slides.spaceBetween"
              :pagination="{ clickable: false }"
              :scrollbar="{ draggable: false }"
              
              @swiper="onSwiper">

              <swiper-slide v-for="(product) in featured"
                  :key="product.ID" >
                  <featured-item
                    :key="product.ID"
                    :productDetails="product">
                  </featured-item>
              </swiper-slide>
              
              <div class="swiper-scrollbar"></div>
          </swiper>
        </div>            
      </div>      
    </div>    
</template>


<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, { EffectFade, Autoplay, A11y } from 'swiper';
import FeaturedItem from './FeaturedItem.vue';
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import Cloudinary from '../../../utilities/cloudinary';
import * as GCONST from '../../../constants.js';
import axiosvl from "../../../axios/axios-vl.js";
import {scale} from "@cloudinary/base/actions/resize";
import { mapGetters } from 'vuex';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/effect-fade/effect-fade.scss';

SwiperCore.use([EffectFade, Autoplay, A11y ]);

export default {
  components : {
    Swiper,
    SwiperSlide,
    FeaturedItem
  },

  props : {
    sliderPerPage : {
      type: Number
    }
  },

  data() {
    return {
      // slidesPerPage : 4,
      featured: [],

      sliderProps: {
        perPage       : this.sliderPerPage,
        spaceBetween  : 20,
      }
    };
  },
  
  methods: {
      onSwiper(swiper) {
          this.controlledSwiper = swiper;
      },
      swiperPrev() {
          this.controlledSwiper.slidePrev();
      },

      swiperNext() {
          this.controlledSwiper.slideNext();
      },

      getProductDetails(metadata, image, feat_name){
          // console.log(image);
          const itemsku = metadata.itemsku;
          const manufacturer = metadata.mfgcode
          axiosvl.post(this.$store.getters['api/product_details_uri'], {
              "webroutine": {
                  "context": {
                      "session-key-method": "hidden"
                  },   
                  "fields": {
                      "EHCUST": { "value": this.$store.getters['customer'] },
                      "EIMFGC": { "value": manufacturer },
                      "EIITMC": { "value": itemsku },
                  },   
              }
          })
          .then((response) => {
              const fields = response.data.webroutine.fields;

              if (fields.RESULTCOD.value === 'OK') {

                  const linetotal = 1 * fields.EIEXCP.value;
                  const defaultLoc = this.$store.getters.getCustomerDetails;
                  const clearProductDesc = encodeURIComponent(fields.IMDESC.value);

                  this.prod = {
                      ID: fields.IMITMC.value,
                      IMITMC: fields.IMITMC.value,
                      item: fields.IMITMC.value,
                      desc: fields.IMDESC.value,
                      feat_name: feat_name,
                      manufacturer: fields.IMMFGC.value,
                      image: image,
                      quantity: this.requestedQuantity,
                      corecharge: fields.EICORP.value,
                      yourprice: fields.EIEXCP.value,
                      listprice: fields.EILSTP.value,
                      shipping: 0,
                      linetotal: linetotal,
                      stockquantity: fields.QTYAVL.value,

                      mfgSeo: fields.MCNAME.value.replace(/ /g, "-"),
                      itemSeo: clearProductDesc,

                      locationid: fields.CMDLOC.value,
                      locationname: defaultLoc.defaultlocationname,
                      locationcity: defaultLoc.defaultlocationcity,
                      locationstate: defaultLoc.defaultlocationstate,

                      XRMFGC: fields.XRMFGC.value,
                      XRITMC: fields.XRITMC.value,
                      IMIGSA: fields.IMIGSA.value,
                      IMISVALID: fields.IMISVALID.value,

                      stars_rating: 5,
                      reviews: 5,
                      metadata: metadata,
                  };

                  this.featured.push(this.prod);
              }else{
                  this.isloading = false;
              }
          })
          .catch((error) => {
              console.log("error - " + error);
          });
      },

      getFeaturedProducts() {
        const clApi = new CloudinaryApi;

        // large image
        clApi.vlLatestProducts(GCONST.CL_METARTYPE_FEATURED).then(images => {
            // console.log(images);
            if(images){
                images.forEach(img => {
                    // console.log(img.metadata);
                    if (img.metadata.itemsku && img.metadata.mfgcode){
                        const clImage = Cloudinary.image(img.publicId);
                        clImage.resize(scale().width(GCONST.Featured_Product));

                        this.getProductDetails(img.metadata, clImage.toURL(), img.metadata.name);
                    }                  
                });
            }
        });
      },

      slides_upd() {
        const width = window.innerWidth;
        let slides = this.sliderProps;

        slides.perPage = this.sliderPerPage;
        slides.spaceBetween = 20;

        if(width <= 1300 ){
          slides.perPage = 4;
          slides.spaceBetween = 20;
        }

        if(width <= 1000 ){
          slides.perPage = 3;
          slides.spaceBetween = 16;
        }


        if(width <= 750 ){
          slides.perPage = 2;
          slides.spaceBetween = 10;
        }

        if(width <= 500 ){
          slides.perPage = 1;
          slides.spaceBetween = 0;
        }

        this.sliderProps = slides;

        // console.log(this.sliderProps);

        // return slides;
    },
      
  },
    
  computed: {
    ...mapGetters([
      "appInitialiazed"
    ]),
    // featured() {
    //   return this.$store.getters['product/featured'];
    // },
    slides() {
      const width = window.innerWidth;
      let slides = this.sliderProps;

      if(width <= 1300 ){
        slides.perPage = 4;
        slides.spaceBetween = 20;
      }

      if(width <= 1000 ){
        slides.perPage = 3;
        slides.spaceBetween = 16;
      }


      if(width <= 750 ){
        slides.perPage = 2;
        slides.spaceBetween = 10;
      }

      if(width <= 500 ){
        slides.perPage = 1;
        slides.spaceBetween = 0;
      }
      // console.log(slides);
      return slides;
    },

  },

  watch: {
    appInitialiazed(newVal) {
      if(newVal == true){
        this.getFeaturedProducts();
      }
    }
  },

  mounted() {
      window.onresize = () => {
          this.windowWidth = window.innerWidth;
          // console.log('onresize width = ' + this.windowWidth);
          
          setTimeout(() => {
            this.slides_upd();
          }, 500);   
      }
  },

  created() {
      // get cloudinary image
    if(this.appInitialiazed ==  true){
      this.getFeaturedProducts();
    }
  }

}
</script>

<style>
    #swiperFeatured{
        min-height: 350px;
    }
    #swiperFeatured .swiper-pagination-bullets{
        display: none;
    }

    #swiperFeatured  .swiper-scrollbar{
        display: none;
    }

    /* #swiperFeatured .swiper-slide{
      width: 250px !important;
      margin-right: 20px;
    } */

    /* .swiper-slide.swiper-slide-prev{
      margin-right: 0px !important;
    } */

    @media screen and (max-width: 820px){
      /* #swiperFeatured .swiper-slide{
        width: 217.333px !important;
        margin-right: 14px;
      } */
    }

    @media screen and (max-width: 742px){
        /* #swiperFeatured .swiper-slide{
          width: 247px !important; 
          margin-right: 16px;
          margin-left: 0px;
        } */
    }

    @media screen and (max-width: 400px){
        /* #swiperFeatured .swiper-slide{
          width: 250px !important;
          margin-right: 20px;
        } */
    }
</style>